import {
  Condition,
  SubjectLineMatchType,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import {
  ConditionType,
  ConditionTypeDetailsProps,
} from "../../return-flow/condition";
import { displayStringForMatchCondition } from "../rule-utils";

export type MessageBodyMatchesState = Omit<
  Condition.MessageBodyMatches,
  "type"
>;

export const MESSAGE_BODY_MATCHES = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<MessageBodyMatchesState>
  >,
): ConditionType<MessageBodyMatchesState, Condition.MessageBodyMatches> => ({
  name: "Message body",
  description(state) {
    return displayStringForMatchCondition(
      "Message body",
      state.matchMode === "INCLUDES"
        ? SubjectLineMatchType.CONTAINS
        : SubjectLineMatchType.EXACT,
      state.queryStrings,
    );
  },
  Details(props: ConditionTypeDetailsProps<MessageBodyMatchesState>) {
    return React.createElement(Details, props);
  },
  empty: { queryString: "", caseSensitive: false, matchMode: "INCLUDES" },
  fromModel(model) {
    return {
      queryStrings: model.queryStrings || [model.queryString || ""],
      caseSensitive: model.caseSensitive,
      matchMode: model.matchMode,
    };
  },
  toModel(state) {
    return { type: Condition.MESSAGE_BODY_MATCHES, ...state };
  },
  valid(state) {
    return (state.queryStrings?.length || 0) > 0;
  },
});
